module.exports = __webpack_public_path__ + "static/media/039-smartwatch.2bd567ae.svg";